export default __webpack_public_path__ + "static/media/next-image.80ce589a.png";